import * as React from "react";
import { Context } from "./_context";
export const PendingFillIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1ZM4.5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z", fill: "currentColor" }));
  return iconset[size];
};
PendingFillIcon.iconId = "oxgTT8";
